import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { updateCard } from '../../../actions/cardActions'
import { cardUpdateReset } from '../../../reducers/cardReducers'
import Loader from '../../Loader'
import Message from '../../Message'
import UpdateProfileForm from '../../UpdateProfileForm'
import { COLORS } from '../../../constants/colors'

function UpdateCCModal({card, pvCardNumber, show, onHide, deleteModalShow, dispatch}) {

    const [cardNumber, setCardNumber] = useState(pvCardNumber);
    const [cardOwner, setCardOwner] = useState(card.cardOwner);
    const [expDate, setExpDate] = useState(card.expDate);
    const [ccv, setCcv] = useState(card.ccv);
    const [cardType, setCardType] = useState(card.cardType || 'credit');
    const [message, setMessage] = useState('');

    const {
        cardReducers: { cardUpdateError, cardUpdateSuccess, createUpdateLoading }
    } = useSelector((state) => state);

    useEffect(() => {
        if(cardUpdateSuccess){
            dispatch(cardUpdateReset())
            onHide()
        }
    },[dispatch, cardUpdateSuccess, onHide]);

    useEffect(() => {
        if(cardUpdateError){
            setMessage('')
        }
    }, [cardUpdateError])

    useEffect(() => {
        if(message){
            dispatch(cardUpdateReset())
        }
    },[message, dispatch])

    const submitHandler = (e) =>{
        e.preventDefault();

        let clearCardNumber = cardNumber.replaceAll(' ', '');

        const updatedCardInfo = {
            "_id": card._id,
            "cardOwner": cardOwner,
            "expDate": expDate,
            "ccv": ccv,
            "cardType": cardType
        };

        if(cardNumber !== pvCardNumber && clearCardNumber !== card.cardNumber){
            updatedCardInfo.cardNumber = clearCardNumber
        };

        dispatch(updateCard(updatedCardInfo))
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton className='border-0' />            
            <Col className='fw-bold fs-4 text-center'>Update Credit Card</Col>
            <Modal.Body>
                <UpdateProfileForm>
                    {cardUpdateError ? (<Message variant='danger'>{cardUpdateError}</Message>)
                    : message ? (<Message variant='danger'>{message}</Message>)
                    : null }
                    {createUpdateLoading && <Loader />}
                    <Form onSubmit={submitHandler}>
                        <Form.Group controlId='Card Number'>
                            <Form.Label className='my-2 fw-semibold'>Card Number</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='Enter Card Number'
                                maxLength={19}
                                value={cardNumber}
                                onChange={
                                    (e) => {
                                        let val = e.target.value.replaceAll(' ', '')
                                        if (/^[0-9\b]/.test(val) || val === '') {
                                            const matches = val.match(/.{1,4}/g)
                                            val = matches ? matches.join(' ') : ''
                                            setCardNumber(val)
                                        }
                                }}
                                inputMode='numeric'
                            />
                        </Form.Group>

                        <Form.Group controlId='Card Owner'>
                            <Form.Label className='my-2 fw-semibold'>Card Owner</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='Enter Card Owner'
                                value={cardOwner}
                                onChange={(e) => setCardOwner(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId='Expiration Date'>
                            <Form.Label className='my-2 fw-semibold'>Expiration Date</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='MM/YY'
                                maxLength={5}
                                value={expDate}
                                onChange={(e) => setExpDate(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId='CVV'>
                            <Form.Label className='my-2 fw-semibold'>CVV</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='CVV'
                                maxLength={4}
                                value={ccv}
                                onChange={(e) => setCcv(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId='Card Type'>
                            <Form.Label className='my-2 fw-semibold'>Card Type</Form.Label>
                            <Form.Select
                                value={cardType}
                                onChange={(e) => setCardType(e.target.value)}
                            >
                                <option value="credit">Credit Card</option>
                                <option value="debit">Debit Card</option>
                            </Form.Select>
                        </Form.Group>

                        <Row className='py-3'>
                            <Col>
                                <Button
                                    type='submit'
                                    style={{ backgroundColor: COLORS.SAGE_GREEN, borderColor: COLORS.WARM_CONCRETE }}
                                    className='my-3 w-100'
                                >
                                    Update
                                </Button>
                            </Col>
                            
                        </Row>
                    </Form>
                </UpdateProfileForm>
            </Modal.Body>
        </Modal>
    )
}

export default UpdateCCModal
